import { ReactNode } from 'react';

import { Icon } from '@pelando/components';
import { ChevronRight } from '@pelando/fontawesome/icons';
import { useTranslation } from '@/presentation/hooks/useTranslation';

import {
  Container,
  CustomButton,
  CustomComparatorIcon,
  Footer,
  Header,
  HeaderContent,
  SubtitleContainer,
  TitleContainer,
} from './style';

export type DealComparatorSectionProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  showComparareButton?: boolean;
  children?: ReactNode;
  className?: string;
  onCompareButtonClick?: () => void;
};

// TODO: Mover esse componente para a pasta de componentes globais porque ele também será utilizado em outros contextos

export const DealComparatorSection = ({
  title,
  subtitle,
  showComparareButton = false,
  children,
  className,
  onCompareButtonClick = () => {},
}: DealComparatorSectionProps) => {
  const { t } = useTranslation('deal');

  return (
    <Container className={className}>
      <Header>
        <HeaderContent>
          <TitleContainer>
            <CustomComparatorIcon />
            {title}
          </TitleContainer>
          {!!subtitle && <SubtitleContainer>{subtitle}</SubtitleContainer>}
        </HeaderContent>
        {showComparareButton && (
          <CustomButton onClick={onCompareButtonClick}>
            {t('comparator-trigger-section-call-to-action')}
            <Icon icon={ChevronRight} />
          </CustomButton>
        )}
      </Header>
      {children}
      {showComparareButton && (
        <Footer>
          <CustomButton onClick={onCompareButtonClick}>
            {t('comparator-trigger-section-call-to-action')}
            <Icon icon={ChevronRight} />
          </CustomButton>
        </Footer>
      )}
    </Container>
  );
};
